import { Card, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
const LevelsComponent = ({language, selectedLevel, data}) => {

  return(
    <>
      <Card className="filters">
        <Card.Header>Poziomy edukacyjne</Card.Header>
        <ListGroup className="list-group-flush">
            {
              data.map((item) => {
                return(
                  <ListGroup.Item key={item._id} className={selectedLevel === item.short ? "active" : null}><a href={"/" + language + "/" + item.short}>{item.long}</a></ListGroup.Item>
                )
              })
            }
          </ListGroup>
      </Card>
    </>
  )

}
export default LevelsComponent;